import React, { useEffect } from 'react'
import Header from '../Components/Header'
import { Avatar, Box, Container, Icon, IconButton, Typography } from '@mui/material'
import demo from "../Files/demo.svg"
import support from "../Files/support.svg"
import renseignement from "../Files/renseignement.svg"
import image from "../Files/Titles/career.png"
import Footer from '../Components/Footer'
import illustation from "../Files/Career Illustration.svg"
import photo from "../PXL_20231009_125631885.jpg"
import Project from '../Components/Project'
import { LinkedIn, GitHub, Instagram, Facebook, Mail, Description, FormatQuote, PostAdd } from '@mui/icons-material'
import cover from "../cover1.jpg";
import cover1 from "../1.jpg";
import cover2 from "../2.jpg";
import cover3 from "../3.jpg";
import cover4 from "../4.jpg";
import { useTranslation } from 'react-i18next'
import SocialLink from '../Components/SocialLink'
import Formations from "../Data/Formations.json";
import { Carousel } from 'antd'
import TopHeader from '../Components/TopHeader'
import TitrePage from './TitrePage'
import { motion, Variants } from 'framer-motion'
import { title } from 'process'
import TitrePartie from '../Components/TitrePartie'
import ellipse6 from "../Files/ellipse6.svg";
import { useNavigate } from 'react-router-dom'

interface Props { }

function Carriere(props: Props) {
    const { } = props
    const { t, i18n } = useTranslation();
    const navigate = useNavigate()
    const scroll: Variants = {
        offscreen: {
            x: -30,
            opacity: .5
        },
        onscreen: {
            x: 0,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };
    const scroll3: Variants = {
        offscreen: {
            y: -30,
            opacity: .5
        },
        onscreen: {
            y: 0,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };
    const scroll1: Variants = {
        offscreen: {
            x: 30,
            opacity: .5
        },
        onscreen: {
            x: 0,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };

    return (
        <div style={{ backgroundColor: "inherit" }} >
            <TopHeader />
            <Header /><br />
            <TitrePage image={image} titre={'titrePage.carriere.titre'} lien='carriere' pageDescription={'titrePage.carriere.description'} keyWords={'titrePage.carriere.keywords'} />
            <br /><br />
            <Container>
                <button style={{ float: "right" }} className='btn4'><PostAdd /> <label htmlFor="">{t("Carriere.texte19").toUpperCase()}</label> </button>
            </Container>
            <Box>
                <Container>
                    <br />

                    <br /><br />
                    {/* <br /><br />
                    <center><SocialLink /></center> */}
                    <TitrePartie titre={t("Carriere.texte1")} />
                    <br />
                    <Box sx={{ display: { xs: 'block', md: 'flex' } }} gap={10}>

                        <Box id='about' className={"text"}>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: false, amount: 0.8 }}
                                variants={scroll}
                            >
                                <label style={{ fontWeight: 'lighter' }} htmlFor="">
                                    <Typography variant='h5' textAlign={"left"} >
                                        {t("Carriere.texte2")}
                                    </Typography><br />
                                    <Typography fontWeight={"lighter"} textAlign={"justify"} >
                                        {t("Carriere.texte3")}
                                        <br />
                                        <br />
                                        <button onClick={(event) => {
                                            const anchor = (
                                                (event.target as HTMLDivElement).ownerDocument || document
                                            ).querySelector('#back-to-top-anchor');

                                            if (anchor) {
                                                anchor.scrollIntoView({
                                                    block: 'center',
                                                });
                                            };
                                            navigate("/")
                                        }} className='btn'>{t("Carriere.texte4")}</button>
                                    </Typography>
                                </label>
                            </motion.div>

                        </Box>
                        <Box>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: false, amount: 0.8 }}
                                variants={scroll3}
                            ><img width={"100%"} draggable={false} className='ill' src={illustation} alt="" /></motion.div>
                        </Box>

                    </Box>
                    <br /><br />
                    {/* <Box display={{ xs: "block", md: "flex" }}>
                        {Motifs.map((f, index) => (
                            <Project buttonName={t("CarriereUs")} showBtn logo={f.image} link={f.link} linkName={f.title} date={""} title={f.title.split("|")[i18n.language == "fr" ? 0 : 1]} description={f.provider.split("|")[i18n.language == "fr" ? 0 : 1]} />
                        ))}
                    </Box>
                    <br /> */}

                </Container>
                <Box style={{ backgroundColor: "rgba(125, 125, 253, .1)" }}>
                    <Container >

                        <br />
                        <TitrePartie titre={t("Carriere.texte5")} /> <br /><br />

                        <Box gap={2} sx={{ display: { xs: 'block', md: 'flex' } }}>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: false, amount: 0.8 }}
                                variants={scroll}
                                className='box'
                            >
                                <label style={{ fontWeight: "bold", fontSize: "50px", }} htmlFor="">1</label><br /><br />
                                <label style={{ fontWeight: "bold", fontSize: "20px", }} htmlFor="">{t("Carriere.Valeurs.valeur1.titre")}</label><br /><br />
                                <label style={{ fontWeight: "lighter" }} htmlFor="">{t("Carriere.Valeurs.valeur1.contenu")}</label><br />

                            </motion.div>
                            <br />
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: false, amount: 0.8 }}
                                variants={scroll}
                                className='box'
                            >
                                <label style={{ fontWeight: "bold", fontSize: "50px", }} htmlFor="">2</label><br /><br />
                                <label style={{ fontWeight: "bold", fontSize: "20px", }} htmlFor="">{t("Carriere.Valeurs.valeur2.titre")}</label><br /><br />
                                <label style={{ fontWeight: "lighter" }} htmlFor="">{t("Carriere.Valeurs.valeur2.contenu")}</label><br />
                            </motion.div>
                            <br />
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: false, amount: 0.8 }}
                                variants={scroll1}
                                className='box'
                            >
                                <label style={{ fontWeight: "bold", fontSize: "50px", }} htmlFor="">3</label><br /><br />
                                <label style={{ fontWeight: "bold", fontSize: "20px", }} htmlFor="">{t("Carriere.Valeurs.valeur3.titre")}</label><br /><br />
                                <label style={{ fontWeight: "lighter" }} htmlFor="">{t("Carriere.Valeurs.valeur3.contenu")}</label><br />
                            </motion.div>


                        </Box>
                        <br />
                        <Box gap={2} sx={{ display: { xs: 'block', md: 'flex' } }}>
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: false, amount: 0.8 }}
                                variants={scroll}
                                className='box'
                            >
                                <label style={{ fontWeight: "bold", fontSize: "50px", }} htmlFor="">4</label><br /><br />
                                <label style={{ fontWeight: "bold", fontSize: "20px", }} htmlFor="">{t("Carriere.Valeurs.valeur4.titre")}</label><br /><br />
                                <label style={{ fontWeight: "lighter" }} htmlFor="">{t("Carriere.Valeurs.valeur4.contenu")}</label><br />
                            </motion.div>
                            <br />
                            <motion.div
                                initial="offscreen"
                                whileInView="onscreen"
                                viewport={{ once: false, amount: 0.8 }}
                                variants={scroll1}
                                className='box'
                            >
                                <label style={{ fontWeight: "bold", fontSize: "50px", }} htmlFor="">5</label><br /><br />
                                <label style={{ fontWeight: "bold", fontSize: "20px", }} htmlFor="">{t("Carriere.Valeurs.valeur5.titre")}</label><br /><br />
                                <label style={{ fontWeight: "lighter" }} htmlFor="">{t("Carriere.Valeurs.valeur5.contenu")}</label><br />

                            </motion.div>

                        </Box>

                    </Container>
                    <br />
                </Box>
                <br />
                <Container>
                    <TitrePartie titre={t("Carriere.texte6")} /> <br /><br />
                    <Box gap={2} sx={{ display: { xs: 'block', md: 'flex' } }}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                            className='box2'
                        >
                            <label style={{ fontWeight: "bold", fontSize: "50px", }} htmlFor="">1</label><br /><br />
                            <label style={{ fontWeight: "bold", fontSize: "20px", }} htmlFor="">{t("Carriere.texte7")}</label><br /><br />
                            <label style={{ fontWeight: "lighter" }} htmlFor="">{t("Carriere.texte8")}</label><br />

                        </motion.div>
                        <br />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                            className='box2'
                        >
                            <label style={{ fontWeight: "bold", fontSize: "50px", }} htmlFor="">2</label><br /><br />
                            <label style={{ fontWeight: "bold", fontSize: "20px", }} htmlFor="">{t("Carriere.texte9")}</label><br /><br />
                            <label style={{ fontWeight: "lighter" }} htmlFor="">{t("Carriere.texte10")}</label><br />
                        </motion.div>
                        <br />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll1}
                            className='box2'
                        >
                            <label style={{ fontWeight: "bold", fontSize: "50px", }} htmlFor="">3</label><br /><br />
                            <label style={{ fontWeight: "bold", fontSize: "20px", }} htmlFor="">{t("Carriere.texte11")}</label><br /><br />
                            <label style={{ fontWeight: "lighter" }} htmlFor="">{t("Carriere.texte12")}</label><br />
                        </motion.div>
                    </Box>
                    <br />
                    <Box gap={2} sx={{ display: { xs: 'block', md: 'flex' } }}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                            className='box2'
                        >
                            <label style={{ fontWeight: "bold", fontSize: "50px", }} htmlFor="">4</label><br /><br />
                            <label style={{ fontWeight: "bold", fontSize: "20px", }} htmlFor="">{t("Carriere.texte13")}</label><br /><br />
                            <label style={{ fontWeight: "lighter" }} htmlFor="">{t("Carriere.texte14")}</label><br />

                        </motion.div>
                        <br />
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll1}
                            className='box2'
                        >
                            <label style={{ fontWeight: "bold", fontSize: "50px", }} htmlFor="">5</label><br /><br />
                            <label style={{ fontWeight: "bold", fontSize: "20px", }} htmlFor="">{t("Carriere.texte15")}</label><br /><br />
                            <label style={{ fontWeight: "lighter" }} htmlFor="">{t("Carriere.texte16")}</label><br />
                        </motion.div>
                    </Box>
                    <br />
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: false, amount: 0.8 }}
                        variants={scroll3}
                    >
                        <label style={{ fontWeight: "bold", fontSize: "20px", }} htmlFor="">{t("Carriere.texte17")}</label><br /><br />
                        <label style={{ fontWeight: "lighter" }} htmlFor="">{t("Carriere.texte18")}</label><br />
                    </motion.div>
                    <br />
                    <button className='btn4'><PostAdd /> <label htmlFor="">{t("Carriere.texte19").toUpperCase()}</label> </button>
                    <br /><br />
                </Container>
            </Box>
            <Footer />
        </div>
    )
}

export default Carriere